// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
// Container imports
const TopCallToActionExplainerApp = require('client-v2/logged-out-landing/containers/top-call-to-action/components/explainer-app-smart')
const TopCallToActionExplainerButtons = require('client-v2/logged-out-landing/containers/top-call-to-action/components/explainer-buttons-smart')

const bem = BemEntity('TopCallToActionExplainer')

function TopCallToActionExplainer(props) {
  return tag('div', {
    ref: props.forwardedRef,
    className: classNames(
      bem.block(),
      props.className
    )
  },
    tag('div', {
      className: bem.element('heading', 'bold')
    },
      `Discover the\n`,
      `best of the web`
    ),
    tag('div', {
      className: bem.element('subheading')
    },
      `Mix shows you interesting content\n`,
      `selected by friends & like-minded people`
    ),
    tag(TopCallToActionExplainerApp),
    tag(TopCallToActionExplainerButtons)
  )
}

module.exports = TopCallToActionExplainer
